import {FilterContainerComponent} from './filter-container.component';
import {FilterInputComponent} from './filter-input.component';
import {SearchApiObservableService} from './search-api-observable.service';
import {FilterDirective} from './container/filter.directive';
import {FilterUrlBasedComponent} from './container/filter.url-based.component';
import {FilterCallbackBasedComponent} from './container/filter.callback-based.component';
import {FilterFieldClearDirective} from './filter-field-clear.directive';
import {FilterFieldInputComponent} from './filter-field-input.component';
import {FilterFieldSelectComponent} from './filter-field-select.component';
import {FilterFieldDaterangepickerComponent} from './filter-field-daterangepicker.component';
import {FilterFieldAmountComponent} from './filter-field-amount.component';
import {AmountRangeComponent} from "./amount-range.component";

export * from './filter-container.component';

export const FILTER_COMPONENTS = [
    AmountRangeComponent,
    FilterFieldAmountComponent,
    FilterContainerComponent,
    FilterInputComponent,
    FilterDirective,
    FilterCallbackBasedComponent,
    FilterUrlBasedComponent,
    FilterFieldClearDirective,
    FilterFieldInputComponent,
    FilterFieldSelectComponent,
    FilterFieldDaterangepickerComponent,
];

export const FILTER_PROVIDERS = [
    SearchApiObservableService
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/index.ts